import React from 'react';
import { useActions } from '@common/store-utils/hooks';

import { actions, selectors } from '../model';
import { ModalWindow } from '@entities/settings/ModalWindow';

type props = {};

export const ResultModal: React.FC<props> = () => {
  const { submitRequestConfirm, setResultModalOpen } = useActions(actions);
  const validationErrors = selectors.useValidationError();
  const isOpen = selectors.useIsResultModalOpen();
  const isSuccess = !validationErrors?.length;

  const failExtraContent =
    validationErrors && Array.isArray(validationErrors)
      ? validationErrors.map((e, index) => (
          <React.Fragment key={`${index}-${e}`}>
            <br />
            {e}
          </React.Fragment>
        ))
      : null;

  return (
    <>
      <ModalWindow
        modal_key="submitSuccess"
        forceOpen={!!isOpen && isSuccess}
        closeModalCallback={submitRequestConfirm}
      />
      <ModalWindow
        modal_key="submitFail"
        forceOpen={!!isOpen && !isSuccess}
        closeModalCallback={() => setResultModalOpen(false)}
        extraContent={failExtraContent}
      />
    </>
  );
};
